import React, { useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'

// Assets
import { MAIN_NAV } from 'shared/router'
import { useDispatch, useSelector } from 'react-redux'
import { guidPosition } from 'utils/helper'
import { setPosition } from '../../../redux/slice/guid'
import { authenticatedNavbarIcons } from 'assets/common/cloudinary'


function Index() {
    const chatButtonRef = useRef(null);
    const dispatch = useDispatch();
    const currentStep = useSelector((state) => state.guide.currentStep);
    const location = useLocation()


    const navbarMenu = [
        { title: 'Home', img: [authenticatedNavbarIcons.active.home, authenticatedNavbarIcons.inactive.home], action: MAIN_NAV.HOME },
        { title: 'Match', img: [authenticatedNavbarIcons.active.match, authenticatedNavbarIcons.inactive.match], action: MAIN_NAV.DISCOVER },
        { title: 'Connection', img: [authenticatedNavbarIcons.active.connection, authenticatedNavbarIcons.inactive.connection], action: MAIN_NAV.CONNECTION },
        { title: 'Chat', img: [authenticatedNavbarIcons.active.chat, authenticatedNavbarIcons.inactive.chat], action: MAIN_NAV.CHAT },
    ]



    useEffect(() => {
        const isMobile = window.innerWidth <= 768;

        if (currentStep === 0 && isMobile) {
            const updatePosition = () => {
                if (chatButtonRef.current) {
                    const additionalPosition = { top: -300, left: -50, }
                    guidPosition(chatButtonRef, dispatch, setPosition, additionalPosition);
                }
            };

            // Initial calculation and recalculate on window resize
            updatePosition();
            window.addEventListener('resize', updatePosition);
            return () => window.removeEventListener('resize', updatePosition);
        }
    }, [dispatch, currentStep]);



    return (
        <div className="fixed bottom-0 left-0 z-30 w-full bg-white lg:hidden">
            <div className="flex justify-around">
                {navbarMenu.map((item, index) => {
                    const isActive = location.pathname.startsWith(item.action);
                    return (
                        <Link ref={item?.title === 'Chat' ? chatButtonRef : null} to={item?.action} key={index} className={`md:w-[50px] lg:w-[74px] h-[64px] flex justify-center items-center cursor-pointer`}>
                            <div className='flex flex-col items-center justify-center'>
                                <img src={isActive ? item?.img[0] : item?.img[1]} alt="" />
                                <p className={`bg-white z-[110] font-normal text-[12px] ${isActive ? 'text-[#F83758]' : 'text-[#5D6577]'}`}>{item?.title}</p>
                            </div>
                        </Link>
                    )
                })}
            </div>
        </div>

    )
}

export default Index